import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getCareProviders = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'identNumber', order: 'ASC' }})
    }

    return filterObjectStore(state.careProvider.careProviders.entries, filter);
};
